var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.253,
    height: 7.046,
    viewBox: "0 0 10.253 7.046",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .a{fill:#000FFF;}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16.362,24.22,12.35,20.208l.736-.6,3.276,3.141,5.552-5.57.689.8Z",
    transform: "translate(-12.35 -17.174)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBlue);
export default __webpack_public_path__ + "static/media/check_blue.357b6d317430512c396e0bebdf8f4b33.svg";
export { ForwardRef as ReactComponent };